import axios from "axios";
import router from "../router/index"
import {
  Toast
} from 'vant';

/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, params = {},urlParams = '') {
  params.v = new Date().getTime()
	if(urlParams){
		url = url + '/' + urlParams
	}
  return new Promise((resolve, reject) => {
    let headers = {
      'Content-Type': 'application/json'
    }
    if (localStorage.getItem('token')) {
      headers.Authorization = 'Bearer ' + localStorage.getItem('token')
    }
    axios.post(url, params, {
        headers: headers
      })
      .then(res => {
        if (res.data.code == 0) {
          resolve(res.data);
        } else if (res.data.code == -9) {
          router.replace({
            path: '/login',
            query: {}
          })
        } else {
          Toast({
            message: res.data.message,
            position: 'bottom',
          });
          reject(res)
        }
      })
      .catch(err => {
        Toast.clear();
				let errMsg = JSON.parse(JSON.stringify(err)).message;
				if(errMsg.indexOf('401') >= 0){
					Toast({
					  message: '登录信息错误',
					  position: 'bottom',
					});
					router.replace({
					  path: '/login',
					  query: {}
					})
				}else{
					let e = err.response.data.errors;
					let em = ''
					for( let i in e ){
						if(e[i] instanceof Array){
							e[i].map(r => {
								em += r
							})
						}else{
							em += JSON.stringify(e[i])
						}
					}
					Toast({
					  message: em || '网络异常',
					  position: 'bottom',
					});
				}
        reject(err)
      })
  });
}

export function get(url, params = {},urlParams = '') {
  let headers = {
    'Content-Type': 'application/json'
  }
  if (localStorage.getItem('token')) {
    headers.Authorization = 'Bearer ' + localStorage.getItem('token')
  }
	if(urlParams){
		url = url+'/'+urlParams
	}
  return new Promise((resolve, reject) => {
  axios.get(url, {
      headers: headers,
      params: params
    })
    .then(res => {
      if (res.data.code == 0) {
        resolve(res.data);
      } else if (res.data.code == -9) {
        router.replace({
          path: '/login',
          query: {}
        })
      } else {
        Toast({
          message: res.data.message,
          position: 'bottom',
        });
        reject(res)
      }
    })
    .catch(err => {
      Toast.clear()
			let errMsg = JSON.parse(JSON.stringify(err)).message;
			if(errMsg.indexOf('401') >= 0){
				Toast({
				  message: '登录信息错误',
				  position: 'bottom',
				});
				router.replace({
				  path: '/login',
				  query: {}
				})
			}else{
				let e = err.response.data.errors;
				let em = ''
				for( let i in e ){
					if(e[i] instanceof Array){
						e[i].map(r => {
							em += r
						})
					}else{
						em += JSON.stringify(e[i])
					}
				}
				Toast({
				  message: em || '网络异常',
				  position: 'bottom',
				});
			}
      
      reject(err)
    })
  })
}